import { StyleSheet } from "react-native";

import { COLORS } from "../../configs";

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20
  },
  wrapTaskNav: {
    paddingTop: 20,
    backgroundColor: COLORS.main,
    // borderBottomLeftRadius: 20,
    // borderBottomRightRadius: 20,
    paddingBottom: 24,
    marginBottom: -10
  },
  taskNav: {
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 80,
    backgroundImage: "linear-gradient(to bottom, #50b1b1 -47%,  #262261)",
    height: "fit-content",
    width: "fir-content",
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.16,
    shadowRadius: 5,
    elevation: 2
  },
  btnNav: {
    height: 70,
    flex: 1,
    borderRadius: 100
  },
  btnText: {
    marginTop: 4,
    fontWeight: "bold",
    fontFamily: "poppins",
    fontSize: 8,
    color: "#ffffff"
  },
  active: {
    backgroundImage: "linear-gradient(to top, #ed5a28,  #f5aa3f)",
    flex: 1
  },
  image: {
    width: 27,
    height: 26
  }
});

export default styles;
